var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / BW") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-BW",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#8BBDEA",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#8BBDEA",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 6.66666667,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-4",
    fill: "#262626",
    mask: "url(#mask-2)",
    x: 0,
    y: 8,
    width: 28,
    height: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBw);
export default __webpack_public_path__ + "static/media/BW.ec571c7a67790cd14ba454edeec8794e.svg";
export { ForwardRef as ReactComponent };